import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { map, catchError } from 'rxjs/operators';
import { Compania } from '../models/compania';
import { environment } from '../../../environments/environment';


@Injectable()
export class CompaniaService {

  private urlEndPoint: string = environment.companiaEndPoint;

  constructor(private http: HttpClient) { }

  listarCompanias(): Observable<Compania[]>{
    return this.http.get(this.urlEndPoint).pipe(
      map((response)=> response as Compania[]),
    )
  }
   crearCompania(parametros: Compania): Observable<Compania> {
    return this.http.post(this.urlEndPoint + 'crearCompania',
      parametros, { responseType: 'json' }).pipe(
        map((resultado) => resultado as Compania)
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/compania.service.ts